// Aurora Innovation, Inc. Proprietary and Confidential. Copyright 2026.
import { isDarkMode } from '../../provider/types';
import { blue } from '../primitiveColors/blue';
import { common } from '../primitiveColors/common';
import { green } from '../primitiveColors/green';
import { grey } from '../primitiveColors/grey';
import { mutedYellow } from '../primitiveColors/muted';
import { purple } from '../primitiveColors/purple';
import { red } from '../primitiveColors/red';
import { yellow } from '../primitiveColors/yellow';
var light = {
    default: grey[500],
    soft: grey[400],
    heavy: grey[700],
    active: grey[900],
    action: blue[500],
    action200: blue[300],
    // Same as action in light mode; diverges in dark (grey[50]) for surfaces that invert
    actionAlt: blue[500],
    disabled: grey[400],
    disabled2: grey[500],
    heaviest: common.black,
    black: common.black,
    white: common.white,
    status: {
        error: red[900],
        errorBold: red[600],
        errorBold2: red[400],
        error2: red[700],
        info: blue[700],
        infoBold: blue[500],
        infoBold2: blue[400],
        info2: blue[600],
        success: green[700],
        successBold: green[300],
        success2: green[600],
        success3: green[800],
        warning: yellow[900],
        warningBold: yellow[500],
        warning2: yellow[700],
        warning3: yellow[800],
        special: purple[500],
        specialBold: purple[600]
    }
};
var dark = {
    default: grey[400],
    soft: grey[500],
    heavy: grey[200],
    active: grey[50],
    action: blue[500],
    action200: blue[700],
    actionAlt: grey[50],
    disabled: grey[700],
    disabled2: grey[600],
    heaviest: common.white,
    black: common.black,
    white: common.white,
    status: {
        error: red[300],
        errorBold: red[600],
        errorBold2: red[400],
        error2: red[400],
        info: blue[500],
        infoBold: blue[400],
        infoBold2: blue[300],
        info2: blue[600],
        success: green[400],
        successBold: green[200],
        success2: green[600],
        success3: green[700],
        warning: mutedYellow[500],
        warningBold: yellow[300],
        warning2: mutedYellow[600],
        warning3: yellow[700],
        special: purple[700],
        specialBold: purple[500]
    }
};
export var icon = function(mode) {
    return isDarkMode(mode) ? dark : light;
};

//# sourceMappingURL=icon.js.map